module.exports = __webpack_public_path__ + "img/bell.e8aa22c.svg";